import React from 'react';
import sanitizeHtml from 'sanitize-html';

/**
 *
 *  New Rules needs to be reviewed by InfoSec team
 *
 *  For sanitize options see:
 *  https://github.com/punkave/sanitize-html#what-are-the-default-options
 *
 *  Example:
 *
 *  const customSanitizeOptions = {
 *      allowedTags: ['span'],
 *
 *      allowedAttributes: {
 *          a: ['href', 'name', 'target']
 *      },
 *
 *      ...
 *  }
 *
 *  NOTE: please rememember to Add default configuration from sanitizeHtml
 *
 * */
const customSanitizeOptions = {
	// Add new rules here
	allowedTags: [...sanitizeHtml.defaults.allowedTags, 'span'],
	allowedAttributes: {
		...sanitizeHtml.defaults.allowedAttributes,
		span: ['class']
	}
};

export interface SafeHTMLProps {
	className?: string;
	element?: keyof HTMLElementTagNameMap | React.JSXElementConstructor<any>;
	dangerouslySetInnerHTML: {__html: string};
}

/*
 *
 *  Safe Html - a wrapper which sanitizes the dangerouslySetInnerHTML content
 *  to prevent XSS
 *
 */
export const SafeHTML = ({
	element = 'span',
	className,
	dangerouslySetInnerHTML = {__html: ''}
}: SafeHTMLProps) => {
	const sanitize = (htmlString: string) => {
		const sanitizeOptions = {
			...sanitizeHtml.defaults,
			...customSanitizeOptions
		};
		const safeHtml = sanitizeHtml(htmlString, sanitizeOptions);
		return safeHtml;
	};

	const getHtmlSafeProps = (): object => {
		const {__html} = dangerouslySetInnerHTML;

		if (dangerouslySetInnerHTML && __html) {
			return {
				className,
				dangerouslySetInnerHTML: {
					__html: sanitize(__html)
				}
			};
		}

		return {className};
	};

	let safeElement: ReturnType<typeof React.createElement> | undefined;

	try {
		if (element) {
			safeElement = React.createElement(element, getHtmlSafeProps(), null);
		}
	} catch (e) {
		console.warn('[SafeHtml] Error creating React.createElement with element. ', e);
	}

	return safeElement;
};
